export const isChecked = (creater, checker, approver) => {
    return (Number(approver) === Number(checker) || Number(checker) === Number(creater));
};
